import { NgFor, NgIf } from '@angular/common';
import { Component, Input } from '@angular/core';
import { Site } from '@curbnturf/entities';
import { IonicModule } from '@ionic/angular';

@Component({
  selector: 'curbnturf-enable-modal',
  templateUrl: './enable-modal.component.html',
  styleUrls: ['./enable-modal.component.scss'],
  standalone: true,
  imports: [IonicModule, NgIf, NgFor],
})
export class EnableModalComponent {
  @Input() sites: Site[];
  @Input() publishFunction: () => void;
  @Input() hideFunction: () => void;
}
